import { render, staticRenderFns } from "./webUser.vue?vue&type=template&id=2bdf5b69&scoped=true&"
import script from "./webUser.vue?vue&type=script&lang=js&"
export * from "./webUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdf5b69",
  null
  
)

export default component.exports